import SocketChannels from '../../../../socket_server/SocketChannels';

// The homepage's live match list (services\live_matches\LiveMatchPush) over
// the socket's live_matches channel. A logged-in user's site socket claims the
// channel; a guest gets a guest socket of its own that can hear nothing else.
// The connection opens with the first subscriber and closes with the last.
//
// The socket modules load on subscribe, not at import: the ssr service renders
// the homepage and must not evaluate them.

const listeners = new Set();
let connection = null;

function receive(data) {
	if(data && data.live_matches) {
		listeners.forEach((listener) => listener(data.live_matches));
	}
}

function open(rootWindow) {
	const current = { stopped: false, close: () => {} };
	const isMember = !!(rootWindow.myUser && rootWindow.myUser.id);
	if(isMember) {
		import('components/SocketConnection').then(({ default: socketConnection }) => {
			if(current.stopped) {
				return;
			}
			const release = socketConnection.claimChannels({ channels: [SocketChannels.LIVE_MATCHES] });
			const socket = socketConnection.socketIoConnection;
			socket.on('message', receive);
			current.close = () => {
				socket.off('message', receive);
				release();
			};
		});
	}
	else if(rootWindow.socketServerUrl) {
		import('socket.io-client').then(({ default: io }) => {
			if(current.stopped) {
				return;
			}
			const socket = io.connect(rootWindow.socketServerUrl, {
				transports: ['polling', 'websocket'],
				query: { guest: '1', channels: SocketChannels.LIVE_MATCHES },
			});
			socket.on('message', receive);
			current.close = () => socket.disconnect();
		});
	}
	return current;
}

export function subscribeToLiveMatches(onMessage, rootWindow = window) {
	listeners.add(onMessage);
	if(!connection) {
		connection = open(rootWindow);
	}
	return () => {
		listeners.delete(onMessage);
		if(listeners.size === 0 && connection) {
			connection.stopped = true;
			connection.close();
			connection = null;
		}
	};
}
